import OptimiserStatusApi from 'api/optimiserStatus';
import { OPTIMISER_RUN_STATUS as actionType } from './actionTypes';

const toPlain = data => (data && typeof data.toJS === 'function' ? data.toJS() : data);

const loadInFlight = () => ({ type: actionType.LOAD_IN_FLIGHT });
const loadSuccess = data => ({ type: actionType.LOAD_SUCCESS, data });
const loadFailure = error => ({ type: actionType.LOAD_FAILURE, error });

export const loadRunStatus = () => (dispatch) => {
  dispatch(loadInFlight());
  return OptimiserStatusApi.getRunStatus()
    .then((response) => {
      const data = toPlain(response.data);
      dispatch(loadSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(loadFailure(error));
      throw error;
    });
};

const historyInFlight = () => ({ type: actionType.HISTORY_IN_FLIGHT });
const historySuccess = data => ({ type: actionType.HISTORY_SUCCESS, data });
const historyFailure = error => ({ type: actionType.HISTORY_FAILURE, error });

export const loadRunHistory = () => (dispatch) => {
  dispatch(historyInFlight());
  return OptimiserStatusApi.getRunHistory()
    .then((response) => {
      const data = toPlain(response.data);
      dispatch(historySuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(historyFailure(error));
      throw error;
    });
};

export const observeFinishedRun = ({
  runIdentifier, receivedAt, state, runName, fromDate, toDate, message
}) => ({
  type: actionType.OBSERVE_FINISHED_RUN,
  runIdentifier,
  receivedAt,
  state,
  runName,
  fromDate,
  toDate,
  message
});

export const acknowledgeRun = ({ runIdentifier, receivedAt }) => ({
  type: actionType.ACKNOWLEDGE_RUN, runIdentifier, receivedAt
});
